import React, { useState } from "react";
import { Button } from "antd";

const CustomButton = ({
  buttonType,
  variant,
  buttonText,
  className,
  onClick,
  disabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const buttonStyles = {
    cancel: {
      color: "#06513D",
      background: "#E6EDEB",
      border: "1px solid #06513D",
    },
    ok: {
       background: "#06513D",
      color: "#fff",
      border: "1px solid #06513D",
    },
  };

  const handleClick = async () => {
    if (isLoading || disabled) return;
    setIsLoading(true);

    try {
      if (typeof onClick === "function") {
        await onClick(); // ✅ only call if it's a function
      } else {
        console.warn("onClick is not a function:", onClick);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type={buttonType}
      onClick={handleClick}
      disabled={disabled || isLoading}
      loading={isLoading} // Adds loader icon
      style={buttonStyles[variant]}
      
      className={`font-light px-4 py-2 ${variant === "ok" ? "hover:!bg-[#387464] text-[#06513D]  hover:!text-[#E6EDEB]" : "hover:!bg-[#F8F8F8]  hover:!text-[#06513D]"} ${className}`}
      >
      {buttonText}
    </Button>
  );
};

export default CustomButton;
